import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { OLAF } from 'HubStyleTokens/colors';
import { H1 } from 'UIComponents/elements/headings';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import UIImage from 'UIComponents/image/UIImage';
import MediaQuery from 'marketplace-ui-common/layout/components/MediaQuery';
import * as ScreenSizes from 'ecosystem-marketplace-core/constants/layout/ScreenSizes';
import StyledHeaderWrapper from 'marketplace-ui-common/storefront/components/StyledHeaderWrapper';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner'; // @ts-expect-error untyped import

import headerImageUrl from 'bender-url!ecosystem-marketplace-solutions-base/img/homepage-header-image.png';
const BACKGROUND_COLOR = '#00497D';
const GRADIENT_ANGLE = '193.97deg';
const COMPLEMENTARY_GRADIENT_ANGLE = '327deg';
const START_GRADIENT_COLOR = '#00497D';
const END_GRADIENT_COLOR = '#0FBFBF';
const ImageWrapper = styled.div.withConfig({
  displayName: "HeroSection__ImageWrapper",
  componentId: "sc-1toykrr-0"
})(["position:relative;height:100%;margin-left:-16%;"]);
const StyledUIImage = styled(UIImage).withConfig({
  displayName: "HeroSection__StyledUIImage",
  componentId: "sc-1toykrr-1"
})(["display:block;position:absolute;bottom:0;max-width:130%;max-height:100%;height:auto;"]);
export default function HeroSection({
  onShowFindPartnerWizard,
  isMobileView
}) {
  if (isMobileView) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        color: OLAF
      },
      children: /*#__PURE__*/_jsx(StyledHeaderWrapper, {
        backgroundColor: BACKGROUND_COLOR,
        className: "p-all-5",
        endGradientColor: END_GRADIENT_COLOR,
        gradientAngle: isMobileView ? COMPLEMENTARY_GRADIENT_ANGLE : GRADIENT_ANGLE,
        startGradientColor: START_GRADIENT_COLOR,
        children: /*#__PURE__*/_jsxs(UIFlex, {
          align: "start",
          direction: "column",
          children: [/*#__PURE__*/_jsx(MediaQuery, {
            minScreenSize: ScreenSizes.SM,
            alternate: /*#__PURE__*/_jsx("span", {
              style: {
                fontSize: '16px'
              },
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ecosystem-marketplace-solutions-ui.homepage.header.mobileSubtitle"
              })
            }),
            children: /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(H1, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ecosystem-marketplace-solutions-ui.homepage.header.title"
                })
              }), /*#__PURE__*/_jsx("span", {
                style: {
                  fontSize: '16px'
                },
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ecosystem-marketplace-solutions-ui.homepage.header.subtitle"
                })
              })]
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            className: "m-top-6",
            onClick: onShowFindPartnerWizard,
            use: "tertiary-light",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ecosystem-marketplace-solutions-ui.homepage.header.button"
            })
          })]
        })
      })
    });
  }

  return /*#__PURE__*/_jsx("div", {
    style: {
      color: OLAF
    },
    children: /*#__PURE__*/_jsx(StyledHeaderWrapper, {
      backgroundColor: BACKGROUND_COLOR,
      endGradientColor: END_GRADIENT_COLOR,
      gradientAngle: GRADIENT_ANGLE,
      startGradientColor: START_GRADIENT_COLOR // backgroundImageUrl={blobUrl}
      ,
      children: /*#__PURE__*/_jsx(MainSectionInner, {
        className: "p-bottom-0 p-top-15",
        children: /*#__PURE__*/_jsxs(UIGrid, {
          className: " m-x-15",
          children: [/*#__PURE__*/_jsx(UIGridItem, {
            size: 8,
            children: /*#__PURE__*/_jsxs(UIFlex, {
              align: "start",
              className: " m-bottom-15",
              direction: "column",
              children: [/*#__PURE__*/_jsx(H1, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ecosystem-marketplace-solutions-ui.homepage.header.title"
                })
              }), /*#__PURE__*/_jsx("span", {
                style: {
                  fontSize: '16px'
                },
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ecosystem-marketplace-solutions-ui.homepage.header.subtitle"
                })
              }), /*#__PURE__*/_jsx(UIButton, {
                className: "m-top-6",
                onClick: onShowFindPartnerWizard,
                use: "tertiary-light",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ecosystem-marketplace-solutions-ui.homepage.header.button"
                })
              })]
            })
          }), /*#__PURE__*/_jsx(UIGridItem, {
            size: 4,
            children: /*#__PURE__*/_jsx(ImageWrapper, {
              children: /*#__PURE__*/_jsx(StyledUIImage, {
                src: headerImageUrl,
                responsive: false
              })
            })
          })]
        })
      })
    })
  });
}